import http from './http'

export const apiGetCouplesList = () => http.post('/web/cp/thisWeekRanking')

export const apiGetCouplesGiftList = () => http.post('web/cp/giftRanking')

export const apiGetLastWeekCouples = () => http.post('/web/cp/lastWeekRanking')

export const apiGetCouplesChampion = () => http.post('/web/cp/allCpRankAllList')

export const apiGetMyCouplesList = () => http.post('/web/cp/myCpList')

export const apiCancelCP = (cpid) => http.post('/web/cp/cancelCp', { cpid })



// WEBPACK FOOTER //
// src/helper/couples.js